import { Observable } from 'rxjs';

import type { CountryRegion } from '@core/locations-types';

type CountryCode = string;
export interface CountryRegionEntity {
  id: CountryCode;
  regions: CountryRegion[];
}

export abstract class RegionsHttpClient {
  public abstract fetchRegions(countryCode: string): Observable<CountryRegion[]>;
}
